import { AutocompleteInput } from "@/components/admin";
import { Card } from "@/components/ui/card";
import {
  DataTable,
  List,
  ListActions,
  ReferenceField,
  SearchInput,
  TextField,
} from "../common";

const filters = [<SearchInput key="q" source="q" alwaysOn />];

export const DepartmentList = () => (
  <List
    title="Departments"
    filters={filters}
    actions={<ListActions label="Add Department" />}
    sort={{ field: "name", order: "ASC" }}
  >
    <Card className="border border-border rounded-xl bg-card shadow-sm overflow-hidden">
      <DataTable rowClick="show">
        <DataTable.Col
          source="code"
          label="Code"
          className="font-mono text-xs bg-muted px-2 py-0.5 rounded border"
        />
        <DataTable.Col source="name" label="Department" className="font-semibold" />
        <DataTable.Col label="Head">
          <ReferenceField
            source="head_employee_id"
            reference="employees"
            link={false}
          >
            <TextField source="name" emptyText="-" />
          </ReferenceField>
        </DataTable.Col>
      </DataTable>
    </Card>
  </List>
);

export { AutocompleteInput };
